import { FC, useEffect, useState } from "react";
import { BsArrowUpCircleFill } from "react-icons/bs";

const ScrollToTopComponent: FC = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return showButton ? (
    <button
      onClick={scrollToTop}
      style={{ bottom: 10, right: 10, width: 55, height: 55, zIndex: 999999 }}
      className="position-fixed btn btn-primary rounded-5 border-2 border-white shadow d-flex align-items-center justify-content-center"
    >
      <BsArrowUpCircleFill size={28} color="white" />
    </button>
  ) : null;
};

export default ScrollToTopComponent;
